import IntakeForm from "@/pages/s/intake/[slug]/intake-form";
import CustomerScreenShell from "@/components/customer-screen-shell";
import type { IntakeView } from "@buildpy/core/views/g4b/intake";

/**
 * 간편 접수. 로그인이 없고 주소의 slug 가 곧 조직이다 —
 * 시공사가 카톡·명함 QR 에 붙여 두고, 고객은 휴대폰으로 열어 30초 안에 남긴다.
 *
 * 검색에 걸리지 않게 한다(route head 의 robots). 회사 홈페이지가 아니라 접수 창구라 색인될 이유가 없다.
 */
const Page = ({ data }: { data: IntakeView }) => {
  const { org, slug } = data;

  return (
    <CustomerScreenShell className="p-0">
      <div className="mx-auto w-full max-w-md px-4 pb-8 pt-safe-8">
        <header className="mb-6">
          <h1 className="text-xl font-semibold">{org.name}</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            상담 접수 — 남겨 주시면 담당자가 연락드립니다.
          </p>
        </header>

        <IntakeForm
          areaBandOptions={data.areaBandOptions}
          designers={data.designers}
          mode={data.mode}
          orgName={org.name}
          residenceOptions={data.residenceOptions}
          origin={data.origin}
          site={data.site}
          slug={slug}
        />

        {org.tel && (
          <footer className="mt-8 text-center text-xs text-muted-foreground">
            전화 상담{" "}
            <a className="tap-target relative underline underline-offset-2" href={`tel:${org.tel}`}>
              {org.tel}
            </a>
          </footer>
        )}
      </div>
    </CustomerScreenShell>
  );
};

export default Page;
